import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSiteContent } from '../context/SiteContext';

// Helper to find project by ID from the path
const getProjectIdFromPath = (pathname: string) => {
  const match = pathname.match(/\/projects\/(\d+)/);
  return match ? parseInt(match[1], 10) : null;
};

export const SEO: React.FC = () => {
  const location = useLocation();
  const { siteContent, projects } = useSiteContent();

  useEffect(() => {
    let title = 'GreySoftware - Dijital Çözümler';
    const projectId = getProjectIdFromPath(location.pathname);

    // Dynamic Route Handling
    if (projectId) {
      const project = projects.find(p => p.id === projectId);
      if (project) {
        title = `${project.title} | GreySoftware`;
      }
    } else {
      // Static Route Handling
      switch (location.pathname) {
        case '/':
          title = siteContent.home.heroTitle || 'GreySoftware - Ana Sayfa';
          break;
        case '/services':
          title = 'Hizmetlerimiz | GreySoftware';
          break;
        case '/projects':
          title = 'Projelerimiz | GreySoftware';
          break;
        case '/about':
          title = 'Hakkımızda | GreySoftware';
          break;
        case '/contact':
          title = 'İletişim | GreySoftware';
          break;
        case '/login':
          title = 'Yönetici Girişi | GreySoftware';
          break;
        case '/admin':
          title = 'Yönetim Paneli | GreySoftware';
          break;
      }
    }
    document.title = title;
  }, [location, siteContent, projects]);

  return null;
};